import { CreateProductTemplate } from "@/components/Templates";
import { useEditProductPage } from "@/hooks/useEditProductPage";

export function EditProductPage() {
  const editProduct = useEditProductPage();

  return <CreateProductTemplate {...editProduct} />;
}
